<template>
  <div class="content-confirm-group">
    <div class="content-block">
      <label class="confirm-group-title">{{
        capitalizeFirstLetter(component.label)
      }}</label>
      <div class="action-buttons">
        <div>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :color="corConfirmado"
                v-bind="attrs"
                v-on="on"
                @click="marcarConfirmado"
              >
                <v-icon size="30">mdi-checkbox-outline</v-icon>
              </v-btn>
            </template>
            <span>Confirmar</span>
          </v-tooltip>

          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                icon
                :color="corCancelado"
                v-bind="attrs"
                v-on="on"
                @click="marcarCancelado"
              >
                <v-icon size="30">mdi-close-box-outline</v-icon>
              </v-btn>
            </template>
            <span>Cancelar</span>
          </v-tooltip>
        </div>
      </div>
    </div>
    <template v-if="canceladoAtivo"
      ><RenderPreview
        v-for="field in component.fields"
        :key="field.name"
        :component="field"
      ></RenderPreview
    ></template>
  </div>
</template>
<script>
export default {
  name: 'MultiInsertForm',

  components: {
    RenderPreview: () => import('./RenderPreview.vue'),
  },

  props: {
    component: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      confirmadoAtivo: false,
      canceladoAtivo: false,
    }
  },

  computed: {
    corConfirmado() {
      return this.confirmadoAtivo ? '#0eca27' : 'grey'
    },
    corCancelado() {
      return this.canceladoAtivo ? '#e20808' : 'grey'
    },
  },

  methods: {
    marcarConfirmado() {
      this.confirmadoAtivo = !this.confirmadoAtivo

      if (this.confirmadoAtivo) {
        this.canceladoAtivo = false
      }
    },

    marcarCancelado() {
      this.canceladoAtivo = !this.canceladoAtivo

      if (this.canceladoAtivo) {
        this.confirmadoAtivo = false
      }
    },

    capitalizeFirstLetter(string) {
      if (!string) {
        return ''
      }

      const firstLetter = string.charAt(0)
      const capitalizedFirstLetter = firstLetter.toUpperCase()
      const restOfString = string.slice(1)

      return capitalizedFirstLetter + restOfString
    },
  },
}
</script>
<style scoped>
.content-confirm-group {
  display: flex;
  flex-direction: column;
  padding: 10px;
  border-bottom: 1px solid #cccccc;
}
.confirm-group {
  flex-grow: 1;
  padding-left: 5px;
  flex: 0 0 80%;
}

.action-buttons {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 5px;
  flex: 0 0 20%;
}

.content-block {
  color: #69739e;
  padding: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
</style>
